<template>
  <section v-if="checkMasterTicket">
    <form-render :form.sync="form" :fields="fields" :key="keyFormRender" @send="onAccept">
      <template #buttonsGroupSlot>
        <div class="button--container-claim">
          <b-button variant="outline-primary" title="Editar" @click="changeDisableToEdit" v-show="!flagDisabled">Editar</b-button>
          <b-button variant="outline-danger" title="Cancelar" @click="setDataDefault" v-show="flagDisabled" :disabled="!flagDisabled || checkLoading">Cancelar</b-button>
          <b-button variant="warning" title="Guardar" v-show="flagDisabled" :disabled="!flagDisabled || checkLoading || conditionFailed" type="submit">Guardar</b-button>
        </div>
      </template>
      <template #messageFileSlot>
        <p>El adjunto requerido para la aprobación de Courier ya ha sido cargado. Si desea revisarlo, puede hacerlo en la sección de Registro de archivos.</p>
      </template>
      <template #messageCompensationData>
        <p class="text-danger">Para llenar el campo Obs de estado actual o Obs de estado inicial con la opción "Con finiquito", debes llenar los campos: "Monto aceptación courier" y "Fecha aceptación courier" en la sección "Datos de indemnización"</p>
      </template>
    </form-render>
  </section>
</template>
<script>
import BaseServices from '@/store/services/index'
export default {
  props: ['ticket', 'masterData', 'loading', 'formActive'],
  data() {
    return {
      form: {},
      fields: [],
      visible: false,
      keyFormRender: 0,
      optionsForm: {
        claimOptions: [
          {id: 'Apelaciones', text: 'Apelaciones'},
          {id: 'Aprobado Courier', text: 'Aprobado Courier'},
          {id: 'Perdidas', text: 'Perdidas'},
          {id: 'Sin Información', text: 'Sin Información'},
          {id: 'Acuerdo Comercial', text: 'Acuerdo Comercial'}
        ],
        obsOptions: [
          {id: 'Con finiquito', text: 'Con finiquito'},
          {id: 'Sin finiquito', text: 'Sin finiquito'},
          {id: 'Re-estudio', text: 'Re-estudio'},
          {id: 'Error Ejecutivo', text: 'Error Ejecutivo'},
          {id: 'Error Políticas Op', text: 'Error Políticas Op'},
          {id: 'Error Sistema', text: 'Error Sistema'}
        ]
      },
      valueFormatCurrency: [''],
      flagDisabled: true,
      conditionFailed: false,
      baseService: new BaseServices(this)
    }
  },
  mounted() {
    this.setForm()
  },
  computed: {
    checkMasterTicket() {
      return !!this.ticket && !!this.masterData
    },
    checkLoading() {
      return this.loading === 'loading'
    },
    options() {
      return {
        compensation_status: [...this.optionsForm.claimOptions],
        complaint_status_appreciation: [...this.optionsForm.claimOptions],
        compensation_observation: [...this.optionsForm.obsOptions],
        complaint_status_appreciation_detail: [...this.optionsForm.obsOptions]
      }
    },
    enableFields() {
      return this.ticket?.attachments?.some(el => el.attachment_type_code === 'COURIER_ACCEPTANCE' && el.active === true) || false
    },
    idTicket() {
      return this.ticket?.delivery?.id || this.ticket?.id || null
    }
  },
  watch: {
    formActive(value) {
      if (value !== 'claim-status' && this.flagDisabled) this.disableFields()
    },
    form: {
      immediate: true,
      handler(value) {
        if (value === null || value === undefined) return
        this.checkCourierFileRequire()
        this.checkObsValue()
      },
      deep: true
    }
  },
  methods: {
    checkCourierFileRequire() {
      const valuesCheck = ['Aprobado Courier', 'Acuerdo Comercial']
      const propertyToCheck = ['compensation_status', 'complaint_status_appreciation']
      const conditionNull = propertyToCheck.some(prop => this.form[prop] !== undefined)
      const conditionMatch = propertyToCheck.some(key => valuesCheck.includes(this.form[key]?.id))
      let fileObject = null
      if (conditionNull) {
        if (conditionMatch) {
          const hasAttachment = this.ticket.attachments?.some(el => el.attachment_type_code === 'COURIER_ACCEPTANCE' && el.active === true)
          const fieldMissing = !this.fields.some(el => el.name === 'COURIER_ACCEPTANCE_FILE')
          const messageMissing = !this.fields.some(el => el.name === 'messageFileSlot')
          const objectMessage = {name: 'messageFileSlot', useSlot: true, containerClass: 'col-12'}
          const objectField = { fieldType: 'FieldFile', name: 'COURIER_ACCEPTANCE_FILE', label: 'Adjuntar Archivo Aceptación Courier', containerClass: 'col-12 col-md-6 container-info', validation: 'required', disabled: !this.flagDisabled }
          if (messageMissing) {
            fileObject = hasAttachment ? objectMessage : fieldMissing ? objectField : null
          }
        } else {
          this.removeField('COURIER_ACCEPTANCE_FILE')
          this.removeField('messageFileSlot')
        }
      }
      if (fileObject) {
        this.addObjectField(fileObject, 0)
      }
    },
    checkObsValue() {
      let fileObject = null
      const valuesCheck = ['Con finiquito']
      const propertyToCheck = ['compensation_observation', 'complaint_status_appreciation_detail']
      const conditionNull = propertyToCheck.some(prop => this.form[prop] !== undefined)
      const conditionMatch = propertyToCheck.some(key => valuesCheck.includes(this.form[key]?.id))
      const propertyToCheckEmpty = ['carrier_payment_amount', 'carrier_payment_date']
      const conditionFormDataCheck = this.checkCompensationData(propertyToCheckEmpty)
      if (conditionNull && conditionMatch && !conditionFormDataCheck) {
        fileObject = {name: 'messageCompensationData', useSlot: true, containerClass: 'col-12'}
        this.conditionFailed = true
      } else {
        this.removeField('messageCompensationData')
        this.conditionFailed = false
      }
      if (fileObject && !this.fields.some(el => el.name === 'messageCompensationData')) {
        this.addObjectField(fileObject, 0)
      }
    },
    addObjectField(object, position = 0) {
      const indice = this.fields.length - 1
      this.fields.splice(indice, position, object)
      this.$nextTick(() => {
        this.keyFormRender++
      })
    },
    checkCompensationData(valuesCheck) {
      return valuesCheck.every(el => {
        const value = this.ticket.compensation_data?.[el]
        return value !== undefined && value !== null && value !== ''
      })
    },
    removeField(name) {
      const index = this.fields.findIndex(el => el.name === name)
      if (index !== -1) {
        this.fields.splice(index, 1)
        delete this.form[name]
        this.$nextTick(() => {
          this.keyFormRender++
        })
      }
    },
    setForm() {
      this.fields = [
        {fieldType: 'FieldDatepicker', name: 'date', label: 'Fecha de estado actual', containerClass: 'col-12 col-md-6 container-info', clearable: true},
        {fieldType: 'FieldSelect', name: 'compensation_status', label: 'Estado actual de indemnización', containerClass: 'col-12 col-md-6 container-info', clearable: true, options: this.options.compensation_status},
        {fieldType: 'FieldSelect', name: 'compensation_observation', label: 'Obs de estado actual', containerClass: 'col-12 col-md-6 container-info', clearable: true, options: this.options.compensation_observation},
        {fieldType: 'FieldInput', name: 'compensation_detail', label: 'Detalle de indemnización courier', containerClass: 'col-12 col-md-6 container-info'},
        {fieldType: 'FieldSelect', name: 'complaint_status_appreciation', label: 'Estado inicial de indemnización', containerClass: 'col-12 col-md-6 collapse--space', clearable: true, options: this.options.complaint_status_appreciation},
        {fieldType: 'FieldSelect', name: 'complaint_status_appreciation_detail', label: 'Obs de estado inicial', containerClass: 'col-12 col-md-6 container-info', clearable: true, options: this.options.complaint_status_appreciation_detail},
        {name: 'buttonsGroupSlot', useSlot: true, containerClass: 'col-12'}
      ]
      this.setDataDefault()
    },
    setDataDefault() {
      this.form = {}
      this.removeField('COURIER_ACCEPTANCE_FILE')
      this.removeField('messageFileSlot')
      this.fields.forEach(el => {
        const data = this.ticket.complaint_status_data?.[el.name]
        if (el.name !== 'buttonsGroupSlot' && data) {
          if (el.fieldType === 'FieldSelect') {
            this.$set(this.form, el.name, {...this.options[el.name].find(option => option.id === data)})
          } else if (this.valueFormatCurrency.includes(el.name)) {
            this.form[el.name] = data.toString().replace(/\./g, ',')
          } else {
            this.form[el.name] = data
          }
        }
      })
      this.changeDisable()
    },
    changeDisableToEdit() {
      this.checkCourierFileRequire()
      this.changeDisable()
    },
    changeDisable() {
      // this.checkCourierFileRequire()
      this.$emit('editIn', !this.flagDisabled ? 'claim-status' : 'cancel')
      this.disableFields()
    },
    disableFields() {
      // const valuesCheck = ['compensation_status', 'complaint_status_appreciation']
      const valuesCheck = ['']
      const shouldDisableFields = !this.enableFields
      this.fields.forEach(el => {
        if (valuesCheck.includes(el.name) && shouldDisableFields) {
          el.disabled = true
          el.msgError = 'No se puede editar porque falta adjuntar un archivo de tipo Aceptación Courier'
        } else {
          el.disabled = this.flagDisabled
        }
      })
      this.flagDisabled = !this.flagDisabled
      this.keyFormRender++
    },
    onAccept() {
      this.changeDisable()
      const sendData = {}
      for (const key in this.form) {
        const conditionNull = this.form[key] !== undefined && this.form[key] !== null
        if ((!Object.prototype.hasOwnProperty.call(this.form, key) || key !== 'buttonsGroupSlot') && (key !== 'COURIER_ACCEPTANCE_FILE' && conditionNull)) {
          const element = this.form[key]
          sendData[key] = this.valueFormatCurrency.includes(key) ? parseFloat(element.replace(/[^0-9,]/g, '').replace(',', '.')) : element?.id || element
        }
      }
      if (!!this.form['COURIER_ACCEPTANCE_FILE']) {
        this.uploadAttachmentAcceptance(this.form['COURIER_ACCEPTANCE_FILE'], sendData)
      } else {
        this.emitSaveDataTicket(sendData)
      }
    },
    emitSaveDataTicket(data) {
      this.$emit('saveDataTicket', { complaint_status_data: { ...data }, overwrite_complaint_data: true })
    },
    uploadAttachmentAcceptance(file, sendData) {
      const form = {
        'attachment_type_code': 'COURIER_ACCEPTANCE',
        'confirm_summary': true,
        'send_message': 1,
        'delivery_id': this.idTicket
      }
      this.baseService.callSpecialUploadFile('updateFiles', file, { id: this.idTicket, ticket_id: this.idTicket },  this.$session.get('cas_user'), form, 'files')
        .then(response => {
          if (response.code === 'success') {
            this.emitSaveDataTicket(sendData)
          }
        })
        .catch(err => {
          const text = 'Ocurrió un problema al subir el archivo'
          let textMessage = ''
          if (Array.isArray(err)) {
            textMessage += '<ul style="list-style-type: disc;">'
            err.forEach(element => {
              textMessage += `<li>${element.message}</li>`
            })
            textMessage += '</ul>'
          }
          this.$alert(textMessage ? textMessage : text)
        })
    }
  }
}
</script>